import { useSelector } from 'react-redux';
// Utils
import { getText } from 'i18n/intl';
// Slices
import { dstsSelector, zonesSelector } from 'slices/timeZone.slice';
import type { TDst, TZone } from '@timeedit/types/lib/types';
// Components
import { TEDrawerSection, TEInput } from '@timeedit/ui-components';
// Types
import type { IProps } from './sections.interface';
// Styles
import './GeneralInfo.scss';

const GeneralInfo = ({ timeZone, onChange }: IProps) => {
  const zones: TZone[] = useSelector(zonesSelector);
  const dsts: TDst[] = useSelector(dstsSelector);
  const isEditing = timeZone.id !== 0;
  return (
    <TEDrawerSection label="General info">
      <div className="time-rule-general-info">
        <TEInput.Input
          label="Name"
          tooltip="Name"
          value={timeZone.name}
          onChange={(value) => onChange({ key: 'name', value })}
          placeholder={getText('new_time_rule')}
        />
        <TEInput.Input
          label="ExtId"
          tooltip="ExtId"
          value={timeZone.extId}
          onChange={(value) => onChange({ key: 'extId', value })}
          placeholder={getText('new_time_rule')}
        />
        <TEInput.Select
          label="Time zone"
          tooltip="Time zone"
          value={timeZone.timeZone}
          onChange={(value) => onChange({ key: 'timeZone', value })}
          options={zones.map((zone) => ({
            label: zone.name,
            value: zone.id,
          }))}
          disabled={isEditing}
        />
        <TEInput.Select
          label="Daylight saving time"
          tooltip="Daylight saving time"
          value={timeZone.daylightSavingsTime}
          onChange={(value) => onChange({ key: 'daylightSavingsTime', value })}
          options={dsts.map((dst) => ({
            label: dst.name,
            value: dst.id,
          }))}
          disabled={isEditing}
        />
        <TEInput.PureText
          label="Offset"
          tooltip="Offset"
          value={timeZone.offset}
        />
        <TEInput.PureText
          label="Identifiers"
          tooltip="Identifiers"
          value={
            !timeZone.identifiers || timeZone.identifiers.length === 0
              ? 'None'
              : timeZone.identifiers.join(', ')
          }
        />
        <TEInput.PureText label="Id" tooltip="Id" value={String(timeZone.id)} />
      </div>
    </TEDrawerSection>
  );
};

export default GeneralInfo;
